import { useEffect, useState } from "react";
import usePlacesAutocomplete, { getGeocode } from "use-places-autocomplete";
import useOnclickOutside from "react-cool-onclickoutside";
import {
  IconButton,
  InputAdornment,
  OutlinedInput,
  TextareaAutosize,
} from "@mui/material";
import GpsFixedIcon from "@mui/icons-material/GpsFixed";
import PlaceIcon from "@mui/icons-material/Place";
import "./MapsInput.scss";
const MapsInput = (props: any) => {
  const {
    onChange,
    isTextArea,
    defaultValue,
    setFormData,
    formData,
    errorData,
    setErrorData,
  } = props;
  const address = {
    addressLine: "",
    city: "",
    state: "",
    stateCode: "",
    country: "",
    countryCode: "",
    pinCode: "",
  };

  const {
    ready,
    value,
    suggestions: { status, data },
    setValue,
    clearSuggestions,
  } = usePlacesAutocomplete({
    requestOptions: {
      /* Define search scope here */
    },
    debounce: 300,
  });
  const [isFocused, setIsFocused] = useState(false);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const ref = useOnclickOutside(() => {
    // When user clicks outside of the component, we can dismiss
    // the searched suggestions by calling this method
    clearSuggestions();
  });

  const handleInput = (e: any) => {
    if (formData) {
      const newForm = { ...formData };
      newForm.address.addressLine1 = e.target.value.addressLine;
      setFormData(newForm);
    }
    setValue(e.target.value);
    setShowSuggestions(true);
  };

  useEffect(() => {
    if (!formData?.address?.addressLine1 && isFocused) {
      if (errorData && setErrorData) {
        setErrorData({
          ...errorData,
          addressError: true,
        });
      }
    }
  }, [formData]);

  const handleSelect =
    ({ description }: any) =>
    () => {
      // When user selects a place, we can replace the keyword without request data from API
      // by setting the second parameter to "false"
      // setValue(description, false);
      clearSuggestions();

      // Get latitude and longitude via utility functions
      getGeocode({ address: description }).then((results) => {
        console.log("results ", results);
        if (errorData && setErrorData) {
          setErrorData({
            ...errorData,
            addressError: false,
          });
        }
        address.addressLine = results[0].formatted_address;
        setValue(address.addressLine, false);
        for (var i = 0; i < results[0].address_components.length; i++) {
          if (results[0].address_components[i].types[0] === "locality") {
            address.city = results[0].address_components[i].long_name;
          } else if (
            results[0].address_components[i].types[0] ===
            "administrative_area_level_1"
          ) {
            address.state = results[0].address_components[i].long_name;
            address.stateCode = results[0].address_components[i].short_name;
          } else if (results[0].address_components[i].types[0] === "country") {
            address.country = results[0].address_components[i].long_name;
            address.countryCode = results[0].address_components[i].short_name;
          } else if (
            results[0].address_components[i].types[0] === "postal_code"
          ) {
            address.pinCode = results[0].address_components[i].long_name;
          }
        }
        const event = {
          target: {
            name: "address",
            value: address,
          },
        };
        onChange(event);
        // console.log(address);
        // const { lat, lng } = getLatLng(results[0]);
        // console.log("📍 Coordinates: ", { lat, lng });
      });
    };

  const renderSuggestions = () =>
    data.map((suggestion) => {
      const {
        place_id,
        structured_formatting: { main_text, secondary_text },
      } = suggestion;
      return (
        <div
          className={`flex flex-row items-center pw-border-bottom p-2 ${
            isTextArea ? "bg-white" : "bg-neutral-100"
          } cursor-pointer p-2`}
        >
          <PlaceIcon />
          <li
            key={place_id}
            onClick={handleSelect(suggestion)}
            className="flex flex-row items-center gap-1"
          >
            <p className="font-bold text-neutral-800 text-sm">{main_text}</p>{" "}
            <small>{secondary_text}</small>
          </li>
        </div>
      );
    });
  useEffect(() => {
    if (defaultValue?.addressLine1) {
      setValue(defaultValue.addressLine1);
    }
  }, [defaultValue]);
  const getPosition = () => {
    new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(
        (resp) => {
          resolve({
            longitude: resp.coords.longitude,
            latitude: resp.coords.latitude,
          });
        },
        (err) => {
          reject(err);
        }
      );
    })
      .then((resp: any) => {
        const latLang = {
          lat: resp.latitude,
          lng: resp.longitude,
        };
        console.log(resp);
        getAddress(latLang);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getAddress = (latLang: any) => {
    const geoCoder = new google.maps.Geocoder();
    geoCoder
      .geocode({ location: latLang })
      .then((response) => {
        console.log(response.results[0]);
        console.log(response.results[0].formatted_address);
        setValue(response.results[0].formatted_address);
      })
      .catch((err) => {
        console.log("Geocoder failed due to : " + err);
      });
  };
  return (
    <div ref={ref} className="relative">
      {isTextArea && (
        <TextareaAutosize
          value={value}
          onFocus={() => setIsFocused(true)}
          onChange={handleInput}
          disabled={!ready}
          placeholder=""
          className="pw-width-100 pw-input-field pw-address"
        />
      )}
      {!isTextArea && (
        <div className="">
          <OutlinedInput
            id="outlined-adornment-password "
            className="pw-input-address"
            placeholder="Search Address"
            onChange={handleInput}
            value={value}
            endAdornment={
              <InputAdornment position="end">
                <IconButton onClick={getPosition} edge="end">
                  <GpsFixedIcon />
                </IconButton>
              </InputAdornment>
            }
          />
        </div>
      )}
      {status === "OK" && showSuggestions && (
        <div className="pw-suggestions-dropdown">{renderSuggestions()}</div>
      )}
    </div>
  );
};

export default MapsInput;
